export default __webpack_public_path__ + "static/media/img-stacking-2-banner.26fec28d.png";